// Translations for sQawk - Multi-language support
// Supported languages: English (en), Spanish (es), Portuguese (pt)

export const translations = {
  en: {
    // Common
    sqawk: "sQawk",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    search: "Search",
    submit: "Submit",
    delete: "Delete",
    edit: "Edit",
    share: "Share",
    copy: "Copy",
    copied: "Copied!",
    
    // Auth
    welcomeBack: "Welcome Back",
    signInToContinue: "Sign in to continue",
    signIn: "Sign In",
    signUp: "Sign Up",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    rememberMe: "Remember me",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    login: "Login",
    logout: "Logout",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk Across the World.",
    createProfile: "Create your sQawk Profile Today",
    joinGlobalCommunity: "Join the global community and start connecting",
    getStarted: "Get Started",
    learnMore: "Learn More",
    webelieve: "We believe",
    conversationBeatsClout: "Conversation beats clout. Community beats virality. Authenticity beats algorithms.",
    socialMediaForPeople: "Social Media for People.",
    notForInfluencers: "sQawk is",
    
    // Navigation
    home: "Home",
    findTravelFriends: "Find Travel Friends",
    notifications: "Notifications",
    messages: "Messages",
    communities: "Communities",
    profile: "Profile",
    settings: "Settings",
    admin: "Admin",
    goLive: "Go Live",
    
    // Dashboard
    myTop5Squad: "My Top 5 Squad",
    feed: "Feed",
    forYou: "For You",
    sqawks: "sQawks",
    whatsHappening: "What's happening?",
    shareTo: "Share to",
    mainFeedOnly: "Main feed only",
    addSqawk: "Add sQawk",
    
    // Features
    customizeYourProfile: "Customize Your Profile",
    makeProfileUnique: "Make your profile uniquely yours",
    editProfile: "Edit Profile",
    findFriends: "Find Friends",
    findTravelers: "Find Travelers",
    connectWithTravelers: "Connect with travelers going your way",
    petPicsOfTheDay: "Pet Pics of the Day",
    shareFurryFriends: "Share your furry friends!",
    joinPetCommunity: "Join Pet Community",
    shareMyBusiness: "Share My Business",
    addCompanyInfo: "Add your company info",
    addBusiness: "Add Business",
    
    // Quick Access
    quickAccess: "Quick Access",
    sqawkTrends: "sQawk Themes",
    sqawkCommunities: "sQawk Communities",
    travelFriends: "Travel Friends",
    myBusiness: "My Business",
    boostPromote: "Boost & Promote",
    
    // Notifications
    enableNotifications: "Enable Notifications",
    notificationsEnabled: "Notifications enabled!",
    notificationPromptTitle: "Enable Notifications",
    notificationPromptBody: "Get notified when your Top 5 friends post, even when the app is closed!",
    enable: "Enable",
    notNow: "Not now",
    notificationsBlocked: "Notifications Blocked",
    enableInBrowserSettings: "Enable notifications in your browser settings to receive updates.",
    
    // Posts
    like: "Like",
    comment: "Comment",
    resqawk: "Resqawk",
    postSqawk: "sQawk",
    addPhoto: "Add Photo",
    addVideo: "Add Video",
    addLocation: "Add Location",
    tagFriends: "Tag Friends",
    
    // Profile
    posts: "Posts",
    friends: "Friends",
    points: "Points",
    top5Friends: "Top 5 Friends",
    addToTop5: "Add to Top 5",
    removeFromTop5: "Remove from Top 5",
    sendMessage: "Send Message",
    addFriend: "Add Friend",
    friendRequestSent: "Friend Request Sent",
    
    // Communities
    joinCommunity: "Join Community",
    leaveCommunity: "Leave Community",
    members: "members",
    groupChat: "Group Chat",
    communityFeed: "Community Feed",
    
    // Travel
    travelingTo: "Traveling to",
    destination: "Destination",
    startDate: "Start Date",
    endDate: "End Date",
    lookingFor: "Looking for",
    postTrip: "Post Trip",
    
    // Admin
    adminDashboard: "Admin Dashboard",
    users: "Users",
    analytics: "Analytics",
    broadcast: "Broadcast",
    sendBroadcast: "Send Broadcast",
    broadcastTitle: "Broadcast Title",
    broadcastMessage: "Broadcast Message",
    
    // Languages
    selectLanguage: "Select Language",
    english: "English",
    spanish: "Spanish",
    portuguese: "Portuguese",
    
    // Errors
    error: "Error",
    somethingWentWrong: "Something went wrong",
    tryAgain: "Try again",
    invalidCredentials: "Invalid credentials",
    
    // Time
    justNow: "Just now",
    minutesAgo: "minutes ago",
    hoursAgo: "hours ago",
    daysAgo: "days ago",
    
    // Footer
    madeWithEmergent: "Made with Emergent",
  },
  
  es: {
    // Common
    sqawk: "sQawk",
    loading: "Cargando...",
    save: "Guardar",
    cancel: "Cancelar",
    close: "Cerrar",
    search: "Buscar",
    submit: "Enviar",
    delete: "Eliminar",
    edit: "Editar",
    share: "Compartir",
    copy: "Copiar",
    copied: "¡Copiado!",
    
    // Auth
    welcomeBack: "Bienvenido de Nuevo",
    signInToContinue: "Inicia sesión para continuar",
    signIn: "Iniciar Sesión",
    signUp: "Registrarse",
    email: "Correo Electrónico",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    rememberMe: "Recuérdame",
    dontHaveAccount: "¿No tienes una cuenta?",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    login: "Entrar",
    logout: "Salir",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk Por Todo el Mundo.",
    createProfile: "Crea tu Perfil de sQawk Hoy",
    joinGlobalCommunity: "Únete a la comunidad global y empieza a conectar",
    getStarted: "Comenzar",
    learnMore: "Más Información",
    webelieve: "Creemos que",
    conversationBeatsClout: "La conversación supera la fama. La comunidad supera la viralidad. La autenticidad supera los algoritmos.",
    socialMediaForPeople: "Es una red social para personas.",
    notForInfluencers: "Esto no es una red social para influencers.",
    
    // Navigation
    home: "Inicio",
    findTravelFriends: "Encontrar Amigos de Viaje",
    notifications: "Notificaciones",
    messages: "Mensajes",
    communities: "Comunidades",
    profile: "Perfil",
    settings: "Configuración",
    admin: "Administración",
    goLive: "En Vivo",
    
    // Dashboard
    myTop5Squad: "Mi Top 5",
    feed: "Feed",
    forYou: "Para Ti",
    sqawks: "sQawks",
    whatsHappening: "¿Qué está pasando?",
    shareTo: "Compartir en",
    mainFeedOnly: "Solo feed principal",
    addSqawk: "Añadir sQawk",
    
    // Features
    customizeYourProfile: "Personaliza tu Perfil",
    makeProfileUnique: "Haz tu perfil único",
    editProfile: "Editar Perfil",
    findFriends: "Encontrar Amigos",
    findTravelers: "Encontrar Viajeros",
    connectWithTravelers: "Conecta con viajeros en tu camino",
    petPicsOfTheDay: "Fotos de Mascotas del Día",
    shareFurryFriends: "¡Comparte a tus amigos peludos!",
    joinPetCommunity: "Unirse a Comunidad de Mascotas",
    shareMyBusiness: "Compartir Mi Negocio",
    addCompanyInfo: "Añade información de tu empresa",
    addBusiness: "Añadir Negocio",
    
    // Quick Access
    quickAccess: "Acceso Rápido",
    sqawkTrends: "Tendencias sQawk",
    sqawkCommunities: "Comunidades sQawk",
    travelFriends: "Amigos de Viaje",
    myBusiness: "Mi Negocio",
    boostPromote: "Impulsar y Promocionar",
    
    // Notifications
    enableNotifications: "Activar Notificaciones",
    notificationsEnabled: "¡Notificaciones activadas!",
    notificationPromptTitle: "Activar Notificaciones",
    notificationPromptBody: "¡Recibe notificaciones cuando tus Top 5 amigos publiquen, incluso cuando la app esté cerrada!",
    enable: "Activar",
    notNow: "Ahora no",
    notificationsBlocked: "Notificaciones Bloqueadas",
    enableInBrowserSettings: "Activa las notificaciones en la configuración de tu navegador.",
    
    // Posts
    like: "Me gusta",
    comment: "Comentar",
    resqawk: "Resqawk",
    postSqawk: "sQawk",
    addPhoto: "Añadir Foto",
    addVideo: "Añadir Video",
    addLocation: "Añadir Ubicación",
    tagFriends: "Etiquetar Amigos",
    
    // Profile
    posts: "Publicaciones",
    friends: "Amigos",
    points: "Puntos",
    top5Friends: "Top 5 Amigos",
    addToTop5: "Añadir al Top 5",
    removeFromTop5: "Quitar del Top 5",
    sendMessage: "Enviar Mensaje",
    addFriend: "Añadir Amigo",
    friendRequestSent: "Solicitud de Amistad Enviada",
    
    // Communities
    joinCommunity: "Unirse a la Comunidad",
    leaveCommunity: "Salir de la Comunidad",
    members: "miembros",
    groupChat: "Chat Grupal",
    communityFeed: "Feed de la Comunidad",
    
    // Travel
    travelingTo: "Viajando a",
    destination: "Destino",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    lookingFor: "Buscando",
    postTrip: "Publicar Viaje",
    
    // Admin
    adminDashboard: "Panel de Administración",
    users: "Usuarios",
    analytics: "Análisis",
    broadcast: "Difusión",
    sendBroadcast: "Enviar Difusión",
    broadcastTitle: "Título de la Difusión",
    broadcastMessage: "Mensaje de la Difusión",
    
    // Languages
    selectLanguage: "Seleccionar Idioma",
    english: "Inglés",
    spanish: "Español",
    portuguese: "Portugués",
    
    // Errors
    error: "Error",
    somethingWentWrong: "Algo salió mal",
    tryAgain: "Intentar de nuevo",
    invalidCredentials: "Credenciales inválidas",
    
    // Time
    justNow: "Ahora mismo",
    minutesAgo: "minutos atrás",
    hoursAgo: "horas atrás",
    daysAgo: "días atrás",
    
    // Footer
    madeWithEmergent: "Hecho con Emergent",
  },
  
  pt: {
    // Common
    sqawk: "sQawk",
    loading: "Carregando...",
    save: "Salvar",
    cancel: "Cancelar",
    close: "Fechar",
    search: "Buscar",
    submit: "Enviar",
    delete: "Excluir",
    edit: "Editar",
    share: "Compartilhar",
    copy: "Copiar",
    copied: "Copiado!",
    
    // Auth
    welcomeBack: "Bem-vindo de Volta",
    signInToContinue: "Entre para continuar",
    signIn: "Entrar",
    signUp: "Cadastrar",
    email: "E-mail",
    password: "Senha",
    forgotPassword: "Esqueceu a senha?",
    rememberMe: "Lembrar de mim",
    dontHaveAccount: "Não tem uma conta?",
    alreadyHaveAccount: "Já tem uma conta?",
    login: "Login",
    logout: "Sair",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk Pelo Mundo.",
    createProfile: "Crie seu Perfil sQawk Hoje",
    joinGlobalCommunity: "Junte-se à comunidade global e comece a se conectar",
    getStarted: "Começar",
    learnMore: "Saiba Mais",
    webelieve: "Acreditamos que",
    conversationBeatsClout: "Conversa supera influência. Comunidade supera viralidade. Autenticidade supera algoritmos.",
    socialMediaForPeople: "É uma rede social para pessoas.",
    notForInfluencers: "Isso não é uma rede social para influenciadores.",
    
    // Navigation
    home: "Início",
    findTravelFriends: "Encontrar Amigos de Viagem",
    notifications: "Notificações",
    messages: "Mensagens",
    communities: "Comunidades",
    profile: "Perfil",
    settings: "Configurações",
    admin: "Admin",
    goLive: "Ao Vivo",
    
    // Dashboard
    myTop5Squad: "Meu Top 5",
    feed: "Feed",
    forYou: "Para Você",
    sqawks: "sQawks",
    whatsHappening: "O que está acontecendo?",
    shareTo: "Compartilhar em",
    mainFeedOnly: "Apenas feed principal",
    addSqawk: "Adicionar sQawk",
    
    // Features
    customizeYourProfile: "Personalize seu Perfil",
    makeProfileUnique: "Faça seu perfil único",
    editProfile: "Editar Perfil",
    findFriends: "Encontrar Amigos",
    findTravelers: "Encontrar Viajantes",
    connectWithTravelers: "Conecte-se com viajantes no seu caminho",
    petPicsOfTheDay: "Fotos de Pets do Dia",
    shareFurryFriends: "Compartilhe seus amigos peludos!",
    joinPetCommunity: "Entrar na Comunidade de Pets",
    shareMyBusiness: "Compartilhar Meu Negócio",
    addCompanyInfo: "Adicione as informações da sua empresa",
    addBusiness: "Adicionar Negócio",
    
    // Quick Access
    quickAccess: "Acesso Rápido",
    sqawkTrends: "Tendências sQawk",
    sqawkCommunities: "Comunidades sQawk",
    travelFriends: "Amigos de Viagem",
    myBusiness: "Meu Negócio",
    boostPromote: "Impulsionar e Promover",
    
    // Notifications
    enableNotifications: "Ativar Notificações",
    notificationsEnabled: "Notificações ativadas!",
    notificationPromptTitle: "Ativar Notificações",
    notificationPromptBody: "Receba notificações quando seus Top 5 amigos postarem, mesmo com o app fechado!",
    enable: "Ativar",
    notNow: "Agora não",
    notificationsBlocked: "Notificações Bloqueadas",
    enableInBrowserSettings: "Ative as notificações nas configurações do seu navegador.",
    
    // Posts
    like: "Curtir",
    comment: "Comentar",
    resqawk: "Resqawk",
    postSqawk: "sQawk",
    addPhoto: "Adicionar Foto",
    addVideo: "Adicionar Vídeo",
    addLocation: "Adicionar Local",
    tagFriends: "Marcar Amigos",
    
    // Profile
    posts: "Posts",
    friends: "Amigos",
    points: "Pontos",
    top5Friends: "Top 5 Amigos",
    addToTop5: "Adicionar ao Top 5",
    removeFromTop5: "Remover do Top 5",
    sendMessage: "Enviar Mensagem",
    addFriend: "Adicionar Amigo",
    friendRequestSent: "Solicitação de Amizade Enviada",
    
    // Communities
    joinCommunity: "Entrar na Comunidade",
    leaveCommunity: "Sair da Comunidade",
    members: "membros",
    groupChat: "Chat do Grupo",
    communityFeed: "Feed da Comunidade",
    
    // Travel
    travelingTo: "Viajando para",
    destination: "Destino",
    startDate: "Data de Início",
    endDate: "Data de Término",
    lookingFor: "Procurando",
    postTrip: "Postar Viagem",
    
    // Admin
    adminDashboard: "Painel Admin",
    users: "Usuários",
    analytics: "Análises",
    broadcast: "Transmissão",
    sendBroadcast: "Enviar Transmissão",
    broadcastTitle: "Título da Transmissão",
    broadcastMessage: "Mensagem da Transmissão",
    
    // Languages
    selectLanguage: "Selecionar Idioma",
    english: "Inglês",
    spanish: "Espanhol",
    portuguese: "Português",
    
    // Errors
    error: "Erro",
    somethingWentWrong: "Algo deu errado",
    tryAgain: "Tentar novamente",
    invalidCredentials: "Credenciais inválidas",
    
    // Time
    justNow: "Agora mesmo",
    minutesAgo: "minutos atrás",
    hoursAgo: "horas atrás",
    daysAgo: "dias atrás",
    
    // Footer
    madeWithEmergent: "Feito com Emergent",
  },
  
  fr: {
    // Common
    sqawk: "sQawk",
    loading: "Chargement...",
    save: "Sauvegarder",
    cancel: "Annuler",
    close: "Fermer",
    search: "Rechercher",
    submit: "Envoyer",
    delete: "Supprimer",
    edit: "Modifier",
    share: "Partager",
    copy: "Copier",
    copied: "Copié !",
    
    // Auth
    welcomeBack: "Bon Retour",
    signInToContinue: "Connectez-vous pour continuer",
    signIn: "Se Connecter",
    signUp: "S'inscrire",
    email: "E-mail",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    rememberMe: "Se souvenir de moi",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    login: "Connexion",
    logout: "Déconnexion",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk à Travers le Monde.",
    createProfile: "Créez votre profil sQawk aujourd'hui",
    joinGlobalCommunity: "Rejoignez la communauté mondiale et commencez à vous connecter",
    getStarted: "Commencer",
    learnMore: "En savoir plus",
    webelieve: "Nous croyons que",
    conversationBeatsClout: "La conversation bat l'influence. La communauté bat la viralité. L'authenticité bat les algorithmes.",
    socialMediaForPeople: "C'est un réseau social pour les gens.",
    notForInfluencers: "Ce n'est pas un réseau social pour les influenceurs.",
    
    // Navigation
    home: "Accueil",
    findTravelFriends: "Trouver des Amis de Voyage",
    notifications: "Notifications",
    messages: "Messages",
    communities: "Communautés",
    profile: "Profil",
    settings: "Paramètres",
    admin: "Admin",
    goLive: "En Direct",
    
    // Dashboard
    myTop5Squad: "Mon Top 5",
    feed: "Fil",
    forYou: "Pour Vous",
    sqawks: "sQawks",
    whatsHappening: "Quoi de neuf ?",
    shareTo: "Partager vers",
    mainFeedOnly: "Fil principal uniquement",
    addSqawk: "Ajouter sQawk",
    
    // Features
    customizeYourProfile: "Personnalisez Votre Profil",
    makeProfileUnique: "Rendez votre profil unique",
    editProfile: "Modifier le Profil",
    findFriends: "Trouver des Amis",
    findTravelers: "Trouver des Voyageurs",
    connectWithTravelers: "Connectez-vous avec des voyageurs sur votre chemin",
    petPicsOfTheDay: "Photos de Pets du Jour",
    shareFurryFriends: "Partagez vos amis à fourrure !",
    joinPetCommunity: "Rejoindre la Communauté des Animaux",
    shareMyBusiness: "Partager Mon Entreprise",
    addCompanyInfo: "Ajoutez les infos de votre entreprise",
    addBusiness: "Ajouter Entreprise",
    
    // Quick Access
    quickAccess: "Accès Rapide",
    sqawkTrends: "Tendances sQawk",
    sqawkCommunities: "Communautés sQawk",
    travelFriends: "Amis de Voyage",
    myBusiness: "Mon Entreprise",
    boostPromote: "Booster et Promouvoir",
    
    // Notifications
    enableNotifications: "Activer les Notifications",
    notificationsEnabled: "Notifications activées !",
    notificationPromptTitle: "Activer les Notifications",
    notificationPromptBody: "Recevez des notifications quand vos Top 5 amis postent !",
    enable: "Activer",
    notNow: "Pas maintenant",
    notificationsBlocked: "Notifications Bloquées",
    enableInBrowserSettings: "Activez les notifications dans les paramètres de votre navigateur.",
    
    // Posts
    like: "J'aime",
    comment: "Commenter",
    resqawk: "Resqawk",
    postSqawk: "sQawk",
    addPhoto: "Ajouter Photo",
    addVideo: "Ajouter Vidéo",
    addLocation: "Ajouter Lieu",
    tagFriends: "Taguer Amis",
    
    // Profile
    posts: "Publications",
    friends: "Amis",
    points: "Points",
    top5Friends: "Top 5 Amis",
    addToTop5: "Ajouter au Top 5",
    removeFromTop5: "Retirer du Top 5",
    sendMessage: "Envoyer Message",
    addFriend: "Ajouter Ami",
    friendRequestSent: "Demande d'Ami Envoyée",
    
    // Communities
    joinCommunity: "Rejoindre la Communauté",
    leaveCommunity: "Quitter la Communauté",
    members: "membres",
    groupChat: "Chat de Groupe",
    communityFeed: "Fil de la Communauté",
    
    // Travel
    travelingTo: "Voyage vers",
    destination: "Destination",
    startDate: "Date de Début",
    endDate: "Date de Fin",
    lookingFor: "Recherche",
    postTrip: "Publier Voyage",
    
    // Admin
    adminDashboard: "Tableau de Bord Admin",
    users: "Utilisateurs",
    analytics: "Analyses",
    broadcast: "Diffusion",
    sendBroadcast: "Envoyer Diffusion",
    broadcastTitle: "Titre de la Diffusion",
    broadcastMessage: "Message de la Diffusion",
    
    // Languages
    selectLanguage: "Choisir la Langue",
    english: "Anglais",
    spanish: "Espagnol",
    portuguese: "Portugais",
    french: "Français",
    german: "Allemand",
    chinese: "Chinois",
    hindi: "Hindi",
    italian: "Italien",
    
    // Errors
    error: "Erreur",
    somethingWentWrong: "Quelque chose s'est mal passé",
    tryAgain: "Réessayer",
    invalidCredentials: "Identifiants invalides",
    
    // Time
    justNow: "À l'instant",
    minutesAgo: "minutes",
    hoursAgo: "heures",
    daysAgo: "jours",
    
    // Footer
    madeWithEmergent: "Fait avec Emergent",
  },
  
  de: {
    // Common
    sqawk: "sQawk",
    loading: "Laden...",
    save: "Speichern",
    cancel: "Abbrechen",
    close: "Schließen",
    search: "Suchen",
    submit: "Senden",
    delete: "Löschen",
    edit: "Bearbeiten",
    share: "Teilen",
    copy: "Kopieren",
    copied: "Kopiert!",
    
    // Auth
    welcomeBack: "Willkommen Zurück",
    signInToContinue: "Melden Sie sich an, um fortzufahren",
    signIn: "Anmelden",
    signUp: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    rememberMe: "Angemeldet bleiben",
    dontHaveAccount: "Kein Konto?",
    alreadyHaveAccount: "Haben Sie bereits ein Konto?",
    login: "Login",
    logout: "Abmelden",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk Auf Der Ganzen Welt.",
    createProfile: "Erstellen Sie heute Ihr sQawk-Profil",
    joinGlobalCommunity: "Treten Sie der globalen Gemeinschaft bei",
    getStarted: "Loslegen",
    learnMore: "Mehr erfahren",
    webelieve: "Wir glauben",
    conversationBeatsClout: "Gespräch schlägt Einfluss. Gemeinschaft schlägt Viralität. Authentizität schlägt Algorithmen.",
    socialMediaForPeople: "Es ist soziales Netzwerk für Menschen.",
    notForInfluencers: "Dies ist kein soziales Netzwerk für Influencer.",
    
    // Navigation
    home: "Startseite",
    findTravelFriends: "Reisefreunde finden",
    notifications: "Benachrichtigungen",
    messages: "Nachrichten",
    communities: "Gemeinschaften",
    profile: "Profil",
    settings: "Einstellungen",
    admin: "Admin",
    goLive: "Live gehen",
    
    // Dashboard
    myTop5Squad: "Meine Top 5",
    feed: "Feed",
    forYou: "Für Dich",
    sqawks: "sQawks",
    whatsHappening: "Was passiert?",
    shareTo: "Teilen mit",
    mainFeedOnly: "Nur Haupt-Feed",
    addSqawk: "sQawk hinzufügen",
    
    // Features
    customizeYourProfile: "Passen Sie Ihr Profil an",
    makeProfileUnique: "Machen Sie Ihr Profil einzigartig",
    editProfile: "Profil bearbeiten",
    findFriends: "Freunde finden",
    findTravelers: "Reisende finden",
    connectWithTravelers: "Verbinden Sie sich mit Reisenden auf Ihrem Weg",
    petPicsOfTheDay: "Haustierbilder des Tages",
    shareFurryFriends: "Teilen Sie Ihre pelzigen Freunde!",
    joinPetCommunity: "Haustier-Community beitreten",
    shareMyBusiness: "Mein Geschäft teilen",
    addCompanyInfo: "Firmeninfos hinzufügen",
    addBusiness: "Geschäft hinzufügen",
    
    // Quick Access
    quickAccess: "Schnellzugriff",
    sqawkTrends: "sQawk Themes",
    sqawkCommunities: "sQawk Gemeinschaften",
    travelFriends: "Reisefreunde",
    myBusiness: "Mein Geschäft",
    boostPromote: "Boosten & Bewerben",
    
    // Notifications
    enableNotifications: "Benachrichtigungen aktivieren",
    notificationsEnabled: "Benachrichtigungen aktiviert!",
    notificationPromptTitle: "Benachrichtigungen aktivieren",
    notificationPromptBody: "Erhalten Sie Benachrichtigungen, wenn Ihre Top 5 Freunde posten!",
    enable: "Aktivieren",
    notNow: "Nicht jetzt",
    notificationsBlocked: "Benachrichtigungen blockiert",
    enableInBrowserSettings: "Aktivieren Sie Benachrichtigungen in Ihren Browser-Einstellungen.",
    
    // Posts
    like: "Gefällt mir",
    comment: "Kommentieren",
    resqawk: "Resqawk",
    postSqawk: "sQawk",
    addPhoto: "Foto hinzufügen",
    addVideo: "Video hinzufügen",
    addLocation: "Ort hinzufügen",
    tagFriends: "Freunde markieren",
    
    // Profile
    posts: "Beiträge",
    friends: "Freunde",
    points: "Punkte",
    top5Friends: "Top 5 Freunde",
    addToTop5: "Zu Top 5 hinzufügen",
    removeFromTop5: "Aus Top 5 entfernen",
    sendMessage: "Nachricht senden",
    addFriend: "Freund hinzufügen",
    friendRequestSent: "Freundschaftsanfrage gesendet",
    
    // Communities
    joinCommunity: "Community beitreten",
    leaveCommunity: "Community verlassen",
    members: "Mitglieder",
    groupChat: "Gruppenchat",
    communityFeed: "Community-Feed",
    
    // Travel
    travelingTo: "Reise nach",
    destination: "Ziel",
    startDate: "Startdatum",
    endDate: "Enddatum",
    lookingFor: "Suche nach",
    postTrip: "Reise posten",
    
    // Admin
    adminDashboard: "Admin-Dashboard",
    users: "Benutzer",
    analytics: "Analysen",
    broadcast: "Übertragung",
    sendBroadcast: "Übertragung senden",
    broadcastTitle: "Übertragungstitel",
    broadcastMessage: "Übertragungsnachricht",
    
    // Languages
    selectLanguage: "Sprache wählen",
    english: "Englisch",
    spanish: "Spanisch",
    portuguese: "Portugiesisch",
    french: "Französisch",
    german: "Deutsch",
    chinese: "Chinesisch",
    hindi: "Hindi",
    italian: "Italienisch",
    
    // Errors
    error: "Fehler",
    somethingWentWrong: "Etwas ist schief gelaufen",
    tryAgain: "Erneut versuchen",
    invalidCredentials: "Ungültige Anmeldedaten",
    
    // Time
    justNow: "Gerade eben",
    minutesAgo: "Minuten",
    hoursAgo: "Stunden",
    daysAgo: "Tage",
    
    // Footer
    madeWithEmergent: "Erstellt mit Emergent",
  },
  
  zh: {
    // Common
    sqawk: "sQawk",
    loading: "加载中...",
    save: "保存",
    cancel: "取消",
    close: "关闭",
    search: "搜索",
    submit: "提交",
    delete: "删除",
    edit: "编辑",
    share: "分享",
    copy: "复制",
    copied: "已复制！",
    
    // Auth
    welcomeBack: "欢迎回来",
    signInToContinue: "登录以继续",
    signIn: "登录",
    signUp: "注册",
    email: "电子邮件",
    password: "密码",
    forgotPassword: "忘记密码？",
    rememberMe: "记住我",
    dontHaveAccount: "没有账号？",
    alreadyHaveAccount: "已有账号？",
    login: "登录",
    logout: "退出",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk 遍布全球。",
    createProfile: "今天创建您的 sQawk 个人资料",
    joinGlobalCommunity: "加入全球社区并开始连接",
    getStarted: "开始",
    learnMore: "了解更多",
    webelieve: "我们相信",
    conversationBeatsClout: "对话胜过影响力。社区胜过病毒传播。真实胜过算法。",
    socialMediaForPeople: "这是为人们打造的社交媒体。",
    notForInfluencers: "这不是为网红打造的社交媒体。",
    
    // Navigation
    home: "首页",
    findTravelFriends: "寻找旅行伙伴",
    notifications: "通知",
    messages: "消息",
    communities: "社区",
    profile: "个人资料",
    settings: "设置",
    admin: "管理",
    goLive: "直播",
    
    // Dashboard
    myTop5Squad: "我的 Top 5",
    feed: "动态",
    forYou: "为你推荐",
    sqawks: "sQawks",
    whatsHappening: "有什么新鲜事？",
    shareTo: "分享到",
    mainFeedOnly: "仅主动态",
    addSqawk: "添加 sQawk",
    
    // Features
    customizeYourProfile: "自定义您的个人资料",
    makeProfileUnique: "让您的个人资料独一无二",
    editProfile: "编辑资料",
    findFriends: "寻找朋友",
    findTravelers: "寻找旅行者",
    connectWithTravelers: "与同路旅行者连接",
    petPicsOfTheDay: "今日宠物照片",
    shareFurryFriends: "分享您的毛茸茸的朋友！",
    joinPetCommunity: "加入宠物社区",
    shareMyBusiness: "分享我的业务",
    addCompanyInfo: "添加公司信息",
    addBusiness: "添加业务",
    
    // Quick Access
    quickAccess: "快速访问",
    sqawkTrends: "sQawk 趋势",
    sqawkCommunities: "sQawk 社区",
    travelFriends: "旅行朋友",
    myBusiness: "我的业务",
    boostPromote: "提升和推广",
    
    // Notifications
    enableNotifications: "启用通知",
    notificationsEnabled: "通知已启用！",
    notificationPromptTitle: "启用通知",
    notificationPromptBody: "当您的 Top 5 好友发布时收到通知！",
    enable: "启用",
    notNow: "暂时不",
    notificationsBlocked: "通知被阻止",
    enableInBrowserSettings: "在浏览器设置中启用通知。",
    
    // Posts
    like: "点赞",
    comment: "评论",
    resqawk: "转发",
    postSqawk: "sQawk",
    addPhoto: "添加照片",
    addVideo: "添加视频",
    addLocation: "添加位置",
    tagFriends: "标记朋友",
    
    // Profile
    posts: "帖子",
    friends: "朋友",
    points: "积分",
    top5Friends: "Top 5 好友",
    addToTop5: "添加到 Top 5",
    removeFromTop5: "从 Top 5 移除",
    sendMessage: "发送消息",
    addFriend: "添加朋友",
    friendRequestSent: "好友请求已发送",
    
    // Communities
    joinCommunity: "加入社区",
    leaveCommunity: "离开社区",
    members: "成员",
    groupChat: "群聊",
    communityFeed: "社区动态",
    
    // Travel
    travelingTo: "前往",
    destination: "目的地",
    startDate: "开始日期",
    endDate: "结束日期",
    lookingFor: "寻找",
    postTrip: "发布行程",
    
    // Admin
    adminDashboard: "管理面板",
    users: "用户",
    analytics: "分析",
    broadcast: "广播",
    sendBroadcast: "发送广播",
    broadcastTitle: "广播标题",
    broadcastMessage: "广播消息",
    
    // Languages
    selectLanguage: "选择语言",
    english: "英语",
    spanish: "西班牙语",
    portuguese: "葡萄牙语",
    french: "法语",
    german: "德语",
    chinese: "中文",
    hindi: "印地语",
    italian: "意大利语",
    
    // Errors
    error: "错误",
    somethingWentWrong: "出了点问题",
    tryAgain: "重试",
    invalidCredentials: "无效的凭证",
    
    // Time
    justNow: "刚刚",
    minutesAgo: "分钟前",
    hoursAgo: "小时前",
    daysAgo: "天前",
    
    // Footer
    madeWithEmergent: "由 Emergent 制作",
  },
  
  hi: {
    // Common
    sqawk: "sQawk",
    loading: "लोड हो रहा है...",
    save: "सहेजें",
    cancel: "रद्द करें",
    close: "बंद करें",
    search: "खोजें",
    submit: "जमा करें",
    delete: "हटाएं",
    edit: "संपादित करें",
    share: "साझा करें",
    copy: "कॉपी करें",
    copied: "कॉपी हो गया!",
    
    // Auth
    welcomeBack: "वापस स्वागत है",
    signInToContinue: "जारी रखने के लिए साइन इन करें",
    signIn: "साइन इन",
    signUp: "साइन अप",
    email: "ईमेल",
    password: "पासवर्ड",
    forgotPassword: "पासवर्ड भूल गए?",
    rememberMe: "मुझे याद रखें",
    dontHaveAccount: "खाता नहीं है?",
    alreadyHaveAccount: "पहले से खाता है?",
    login: "लॉगिन",
    logout: "लॉगआउट",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk पूरी दुनिया में।",
    createProfile: "आज अपना sQawk प्रोफाइल बनाएं",
    joinGlobalCommunity: "वैश्विक समुदाय से जुड़ें और कनेक्ट करना शुरू करें",
    getStarted: "शुरू करें",
    learnMore: "और जानें",
    webelieve: "हम मानते हैं",
    conversationBeatsClout: "बातचीत प्रभाव से बेहतर है। समुदाय वायरलिटी से बेहतर है। प्रामाणिकता एल्गोरिदम से बेहतर है।",
    socialMediaForPeople: "यह लोगों के लिए सोशल मीडिया है।",
    notForInfluencers: "यह प्रभावशाली लोगों के लिए सोशल मीडिया नहीं है।",
    
    // Navigation
    home: "होम",
    findTravelFriends: "यात्रा मित्र खोजें",
    notifications: "सूचनाएं",
    messages: "संदेश",
    communities: "समुदाय",
    profile: "प्रोफाइल",
    settings: "सेटिंग्स",
    admin: "एडमिन",
    goLive: "लाइव जाएं",
    
    // Dashboard
    myTop5Squad: "मेरा टॉप 5",
    feed: "फीड",
    forYou: "आपके लिए",
    sqawks: "sQawks",
    whatsHappening: "क्या हो रहा है?",
    shareTo: "में साझा करें",
    mainFeedOnly: "केवल मुख्य फीड",
    addSqawk: "sQawk जोड़ें",
    
    // Features
    customizeYourProfile: "अपना प्रोफाइल कस्टमाइज़ करें",
    makeProfileUnique: "अपने प्रोफाइल को यूनिक बनाएं",
    editProfile: "प्रोफाइल संपादित करें",
    findFriends: "दोस्त खोजें",
    findTravelers: "यात्री खोजें",
    connectWithTravelers: "अपने रास्ते पर यात्रियों से जुड़ें",
    petPicsOfTheDay: "आज की पालतू तस्वीरें",
    shareFurryFriends: "अपने प्यारे दोस्तों को साझा करें!",
    joinPetCommunity: "पेट कम्युनिटी में शामिल हों",
    shareMyBusiness: "मेरा व्यवसाय साझा करें",
    addCompanyInfo: "अपनी कंपनी की जानकारी जोड़ें",
    addBusiness: "व्यवसाय जोड़ें",
    
    // Quick Access
    quickAccess: "त्वरित पहुँच",
    sqawkTrends: "sQawk ट्रेंड्स",
    sqawkCommunities: "sQawk समुदाय",
    travelFriends: "यात्रा मित्र",
    myBusiness: "मेरा व्यवसाय",
    boostPromote: "बूस्ट और प्रमोट",
    
    // Notifications
    enableNotifications: "सूचनाएं सक्षम करें",
    notificationsEnabled: "सूचनाएं सक्षम!",
    notificationPromptTitle: "सूचनाएं सक्षम करें",
    notificationPromptBody: "जब आपके टॉप 5 दोस्त पोस्ट करें तो सूचित हों!",
    enable: "सक्षम करें",
    notNow: "अभी नहीं",
    notificationsBlocked: "सूचनाएं ब्लॉक हैं",
    enableInBrowserSettings: "अपने ब्राउज़र सेटिंग्स में सूचनाएं सक्षम करें।",
    
    // Posts
    like: "पसंद",
    comment: "टिप्पणी",
    resqawk: "रीसक्वॉक",
    postSqawk: "sQawk",
    addPhoto: "फोटो जोड़ें",
    addVideo: "वीडियो जोड़ें",
    addLocation: "स्थान जोड़ें",
    tagFriends: "दोस्तों को टैग करें",
    
    // Profile
    posts: "पोस्ट",
    friends: "दोस्त",
    points: "पॉइंट्स",
    top5Friends: "टॉप 5 दोस्त",
    addToTop5: "टॉप 5 में जोड़ें",
    removeFromTop5: "टॉप 5 से हटाएं",
    sendMessage: "संदेश भेजें",
    addFriend: "दोस्त जोड़ें",
    friendRequestSent: "मित्रता अनुरोध भेजा गया",
    
    // Communities
    joinCommunity: "समुदाय में शामिल हों",
    leaveCommunity: "समुदाय छोड़ें",
    members: "सदस्य",
    groupChat: "ग्रुप चैट",
    communityFeed: "समुदाय फीड",
    
    // Travel
    travelingTo: "यात्रा कर रहे हैं",
    destination: "गंतव्य",
    startDate: "आरंभ तिथि",
    endDate: "समाप्ति तिथि",
    lookingFor: "खोज रहे हैं",
    postTrip: "यात्रा पोस्ट करें",
    
    // Admin
    adminDashboard: "एडमिन डैशबोर्ड",
    users: "उपयोगकर्ता",
    analytics: "विश्लेषण",
    broadcast: "प्रसारण",
    sendBroadcast: "प्रसारण भेजें",
    broadcastTitle: "प्रसारण शीर्षक",
    broadcastMessage: "प्रसारण संदेश",
    
    // Languages
    selectLanguage: "भाषा चुनें",
    english: "अंग्रेज़ी",
    spanish: "स्पेनिश",
    portuguese: "पुर्तगाली",
    french: "फ्रेंच",
    german: "जर्मन",
    chinese: "चीनी",
    hindi: "हिंदी",
    italian: "इतालवी",
    
    // Errors
    error: "त्रुटि",
    somethingWentWrong: "कुछ गलत हो गया",
    tryAgain: "पुनः प्रयास करें",
    invalidCredentials: "अमान्य क्रेडेंशियल",
    
    // Time
    justNow: "अभी",
    minutesAgo: "मिनट पहले",
    hoursAgo: "घंटे पहले",
    daysAgo: "दिन पहले",
    
    // Footer
    madeWithEmergent: "Emergent के साथ बनाया गया",
  },
  
  it: {
    // Common
    sqawk: "sQawk",
    loading: "Caricamento...",
    save: "Salva",
    cancel: "Annulla",
    close: "Chiudi",
    search: "Cerca",
    submit: "Invia",
    delete: "Elimina",
    edit: "Modifica",
    share: "Condividi",
    copy: "Copia",
    copied: "Copiato!",
    
    // Auth
    welcomeBack: "Bentornato",
    signInToContinue: "Accedi per continuare",
    signIn: "Accedi",
    signUp: "Registrati",
    email: "Email",
    password: "Password",
    forgotPassword: "Password dimenticata?",
    rememberMe: "Ricordami",
    dontHaveAccount: "Non hai un account?",
    alreadyHaveAccount: "Hai già un account?",
    login: "Login",
    logout: "Esci",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk In Tutto Il Mondo.",
    createProfile: "Crea il tuo profilo sQawk oggi",
    joinGlobalCommunity: "Unisciti alla comunità globale e inizia a connetterti",
    getStarted: "Inizia",
    learnMore: "Scopri di più",
    webelieve: "Crediamo che",
    conversationBeatsClout: "La conversazione batte l'influenza. La comunità batte la viralità. L'autenticità batte gli algoritmi.",
    socialMediaForPeople: "È un social media per le persone.",
    notForInfluencers: "Questo non è un social media per influencer.",
    
    // Navigation
    home: "Home",
    findTravelFriends: "Trova Amici di Viaggio",
    notifications: "Notifiche",
    messages: "Messaggi",
    communities: "Comunità",
    profile: "Profilo",
    settings: "Impostazioni",
    admin: "Admin",
    goLive: "In Diretta",
    
    // Dashboard
    myTop5Squad: "Il Mio Top 5",
    feed: "Feed",
    forYou: "Per Te",
    sqawks: "sQawks",
    whatsHappening: "Cosa sta succedendo?",
    shareTo: "Condividi su",
    mainFeedOnly: "Solo feed principale",
    addSqawk: "Aggiungi sQawk",
    
    // Features
    customizeYourProfile: "Personalizza il Tuo Profilo",
    makeProfileUnique: "Rendi il tuo profilo unico",
    editProfile: "Modifica Profilo",
    findFriends: "Trova Amici",
    findTravelers: "Trova Viaggiatori",
    connectWithTravelers: "Connettiti con viaggiatori sulla tua strada",
    petPicsOfTheDay: "Foto di Animali del Giorno",
    shareFurryFriends: "Condividi i tuoi amici pelosi!",
    joinPetCommunity: "Unisciti alla Comunità Pet",
    shareMyBusiness: "Condividi la Mia Attività",
    addCompanyInfo: "Aggiungi le info della tua azienda",
    addBusiness: "Aggiungi Attività",
    
    // Quick Access
    quickAccess: "Accesso Rapido",
    sqawkTrends: "Tendenze sQawk",
    sqawkCommunities: "Comunità sQawk",
    travelFriends: "Amici di Viaggio",
    myBusiness: "La Mia Attività",
    boostPromote: "Potenzia e Promuovi",
    
    // Notifications
    enableNotifications: "Abilita Notifiche",
    notificationsEnabled: "Notifiche abilitate!",
    notificationPromptTitle: "Abilita Notifiche",
    notificationPromptBody: "Ricevi notifiche quando i tuoi Top 5 amici pubblicano!",
    enable: "Abilita",
    notNow: "Non ora",
    notificationsBlocked: "Notifiche Bloccate",
    enableInBrowserSettings: "Abilita le notifiche nelle impostazioni del browser.",
    
    // Posts
    like: "Mi piace",
    comment: "Commenta",
    resqawk: "Resqawk",
    postSqawk: "sQawk",
    addPhoto: "Aggiungi Foto",
    addVideo: "Aggiungi Video",
    addLocation: "Aggiungi Posizione",
    tagFriends: "Tagga Amici",
    
    // Profile
    posts: "Post",
    friends: "Amici",
    points: "Punti",
    top5Friends: "Top 5 Amici",
    addToTop5: "Aggiungi al Top 5",
    removeFromTop5: "Rimuovi dal Top 5",
    sendMessage: "Invia Messaggio",
    addFriend: "Aggiungi Amico",
    friendRequestSent: "Richiesta di Amicizia Inviata",
    
    // Communities
    joinCommunity: "Unisciti alla Comunità",
    leaveCommunity: "Lascia la Comunità",
    members: "membri",
    groupChat: "Chat di Gruppo",
    communityFeed: "Feed della Comunità",
    
    // Travel
    travelingTo: "In viaggio verso",
    destination: "Destinazione",
    startDate: "Data di Inizio",
    endDate: "Data di Fine",
    lookingFor: "Cerco",
    postTrip: "Pubblica Viaggio",
    
    // Admin
    adminDashboard: "Pannello Admin",
    users: "Utenti",
    analytics: "Analisi",
    broadcast: "Trasmissione",
    sendBroadcast: "Invia Trasmissione",
    broadcastTitle: "Titolo Trasmissione",
    broadcastMessage: "Messaggio Trasmissione",
    
    // Languages
    selectLanguage: "Seleziona Lingua",
    english: "Inglese",
    spanish: "Spagnolo",
    portuguese: "Portoghese",
    french: "Francese",
    german: "Tedesco",
    chinese: "Cinese",
    hindi: "Hindi",
    italian: "Italiano",
    
    // Errors
    error: "Errore",
    somethingWentWrong: "Qualcosa è andato storto",
    tryAgain: "Riprova",
    invalidCredentials: "Credenziali non valide",
    
    // Time
    justNow: "Proprio ora",
    minutesAgo: "minuti fa",
    hoursAgo: "ore fa",
    daysAgo: "giorni fa",
    
    // Footer
    madeWithEmergent: "Creato con Emergent",
  },
  
  ko: {
    // Common - Korean
    sqawk: "sQawk",
    loading: "로딩 중...",
    save: "저장",
    cancel: "취소",
    close: "닫기",
    search: "검색",
    submit: "제출",
    delete: "삭제",
    edit: "편집",
    share: "공유",
    copy: "복사",
    copied: "복사됨!",
    
    // Auth
    welcomeBack: "다시 오신 것을 환영합니다",
    signInToContinue: "계속하려면 로그인하세요",
    signIn: "로그인",
    signUp: "가입하기",
    email: "이메일",
    password: "비밀번호",
    forgotPassword: "비밀번호를 잊으셨나요?",
    rememberMe: "로그인 유지",
    dontHaveAccount: "계정이 없으신가요?",
    alreadyHaveAccount: "이미 계정이 있으신가요?",
    login: "로그인",
    logout: "로그아웃",
    
    // Landing Page
    sqawkAcrossTheWorld: "전 세계의 sQawk.",
    createProfile: "오늘 sQawk 프로필을 만드세요",
    joinGlobalCommunity: "글로벌 커뮤니티에 참여하고 연결을 시작하세요",
    getStarted: "시작하기",
    learnMore: "더 알아보기",
    webelieve: "우리는 믿습니다",
    conversationBeatsClout: "대화가 영향력을 이깁니다. 커뮤니티가 바이럴을 이깁니다. 진정성이 알고리즘을 이깁니다.",
    socialMediaForPeople: "사람들을 위한 소셜 미디어입니다.",
    notForInfluencers: "인플루언서를 위한 소셜 미디어가 아닙니다.",
    
    // Navigation
    home: "홈",
    findTravelFriends: "여행 친구 찾기",
    notifications: "알림",
    messages: "메시지",
    communities: "커뮤니티",
    profile: "프로필",
    settings: "설정",
    admin: "관리자",
    goLive: "라이브",
    
    // Dashboard
    myTop5Squad: "나의 Top 5 스쿼드",
    feed: "피드",
    forYou: "추천",
    sqawks: "sQawks",
    whatsHappening: "무슨 일이 일어나고 있나요?",
    shareTo: "공유 대상",
    mainFeedOnly: "메인 피드만",
    addSqawk: "sQawk 추가",
    
    // Features
    customizeYourProfile: "프로필 꾸미기",
    makeProfileUnique: "나만의 프로필 만들기",
    editProfile: "프로필 편집",
    findFriends: "친구 찾기",
    findTravelers: "여행자 찾기",
    connectWithTravelers: "여행 중인 친구들과 연결하세요",
    petPicsOfTheDay: "오늘의 반려동물 사진",
    shareFurryFriends: "반려동물을 공유하세요!",
    joinPetCommunity: "반려동물 커뮤니티 참여",
    shareMyBusiness: "내 비즈니스 공유",
    addCompanyInfo: "회사 정보 추가",
    addBusiness: "비즈니스 추가",
    
    // Quick Access
    quickAccess: "빠른 접근",
    sqawkTrends: "sQawk 트렌드",
    sqawkCommunities: "sQawk 커뮤니티",
    travelFriends: "여행 친구",
    myBusiness: "내 비즈니스",
    boostPromote: "부스트 및 프로모션",
    
    // Notifications
    enableNotifications: "알림 활성화",
    notificationsEnabled: "알림이 활성화되었습니다!",
    notificationPromptTitle: "알림 활성화",
    notificationPromptBody: "앱이 닫혀 있어도 Top 5 친구가 게시할 때 알림을 받으세요!",
    enable: "활성화",
    notNow: "나중에",
    notificationsBlocked: "알림이 차단됨",
    enableInBrowserSettings: "브라우저 설정에서 알림을 활성화하세요.",
    
    // Posts
    like: "좋아요",
    comment: "댓글",
    resqawk: "리스쿼크",
    postSqawk: "sQawk",
    addPhoto: "사진 추가",
    addVideo: "동영상 추가",
    addLocation: "위치 추가",
    tagFriends: "친구 태그",
    
    // Profile
    posts: "게시물",
    friends: "친구",
    points: "포인트",
    top5Friends: "Top 5 친구",
    addToTop5: "Top 5에 추가",
    removeFromTop5: "Top 5에서 제거",
    sendMessage: "메시지 보내기",
    addFriend: "친구 추가",
    friendRequestSent: "친구 요청 전송됨",
    
    // Communities
    joinCommunity: "커뮤니티 참여",
    leaveCommunity: "커뮤니티 나가기",
    members: "멤버",
    groupChat: "그룹 채팅",
    communityFeed: "커뮤니티 피드",
    
    // Travel
    travelingTo: "여행지",
    destination: "목적지",
    startDate: "시작일",
    endDate: "종료일",
    lookingFor: "찾는 것",
    postTrip: "여행 게시",
    
    // Admin
    adminDashboard: "관리자 대시보드",
    users: "사용자",
    analytics: "분석",
    broadcast: "브로드캐스트",
    sendBroadcast: "브로드캐스트 보내기",
    broadcastTitle: "브로드캐스트 제목",
    broadcastMessage: "브로드캐스트 메시지",
    
    // Languages
    selectLanguage: "언어 선택",
    english: "영어",
    spanish: "스페인어",
    portuguese: "포르투갈어",
    french: "프랑스어",
    german: "독일어",
    chinese: "중국어",
    hindi: "힌디어",
    italian: "이탈리아어",
    korean: "한국어",
    
    // Errors
    error: "오류",
    somethingWentWrong: "문제가 발생했습니다",
    tryAgain: "다시 시도",
    invalidCredentials: "잘못된 인증 정보",
    
    // Time
    justNow: "방금 전",
    minutesAgo: "분 전",
    hoursAgo: "시간 전",
    daysAgo: "일 전",
    
    // Footer
    madeWithEmergent: "Emergent로 제작",
  },

  // Arabic translations - Complete
  ar: {
    // Common
    sqawk: "sQawk",
    loading: "جاري التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    search: "بحث",
    submit: "إرسال",
    delete: "حذف",
    edit: "تعديل",
    share: "مشاركة",
    copy: "نسخ",
    copied: "تم النسخ!",
    
    // Auth
    welcomeBack: "مرحباً بعودتك",
    signInToContinue: "سجل الدخول للمتابعة",
    signIn: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    rememberMe: "تذكرني",
    dontHaveAccount: "ليس لديك حساب؟",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    login: "دخول",
    logout: "خروج",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk حول العالم.",
    createProfile: "أنشئ ملفك الشخصي على sQawk اليوم",
    joinGlobalCommunity: "انضم إلى المجتمع العالمي وابدأ التواصل",
    getStarted: "ابدأ الآن",
    learnMore: "اعرف المزيد",
    webelieve: "نحن نؤمن",
    conversationBeatsClout: "الحوار يتفوق على الشهرة. المجتمع يتفوق على الانتشار. الأصالة تتفوق على الخوارزميات.",
    socialMediaForPeople: "هذه وسائل تواصل اجتماعي للناس.",
    notForInfluencers: "هذه ليست وسائل تواصل اجتماعي للمؤثرين.",
    
    // Navigation
    home: "الرئيسية",
    findTravelFriends: "ابحث عن رفقاء السفر",
    notifications: "الإشعارات",
    messages: "الرسائل",
    communities: "المجتمعات",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    admin: "الإدارة",
    goLive: "بث مباشر",
    
    // Dashboard
    myTop5Squad: "فريقي المفضل",
    feed: "الخلاصة",
    forYou: "لك",
    sqawks: "المنشورات",
    whatsHappening: "ماذا يحدث؟",
    shareTo: "شارك في",
    mainFeedOnly: "الخلاصة الرئيسية فقط",
    addSqawk: "أضف منشور",
    
    // Features
    customizeYourProfile: "خصص ملفك الشخصي",
    makeProfileUnique: "اجعل ملفك الشخصي فريداً",
    editProfile: "تعديل الملف الشخصي",
    findFriends: "ابحث عن أصدقاء",
    findTravelers: "ابحث عن مسافرين",
    connectWithTravelers: "تواصل مع المسافرين في طريقك",
    petPicsOfTheDay: "صور الحيوانات الأليفة اليوم",
    shareFurryFriends: "شارك صور حيواناتك الأليفة!",
    joinPetCommunity: "انضم لمجتمع الحيوانات",
    shareMyBusiness: "شارك عملي",
    addCompanyInfo: "أضف معلومات شركتك",
    addBusiness: "أضف عمل",
    
    // Quick Access
    quickAccess: "وصول سريع",
    sqawkTrends: "ترندات sQawk",
    sqawkCommunities: "مجتمعات sQawk",
    travelFriends: "رفاق السفر",
    myBusiness: "عملي",
    boostPromote: "تعزيز وترويج",
    
    // Notifications
    enableNotifications: "تفعيل الإشعارات",
    notificationsEnabled: "تم تفعيل الإشعارات!",
    notificationPromptTitle: "تفعيل الإشعارات",
    notificationPromptBody: "احصل على إشعار عندما ينشر أصدقاؤك المفضلون، حتى عند إغلاق التطبيق!",
    enable: "تفعيل",
    notNow: "ليس الآن",
    notificationsBlocked: "الإشعارات محظورة",
    enableInBrowserSettings: "فعّل الإشعارات في إعدادات المتصفح للحصول على التحديثات.",
    
    // Posts
    like: "إعجاب",
    comment: "تعليق",
    resqawk: "إعادة نشر",
    postSqawk: "نشر",
    addPhoto: "أضف صورة",
    addVideo: "أضف فيديو",
    addLocation: "أضف موقع",
    tagFriends: "أشر للأصدقاء",
    
    // Profile
    posts: "المنشورات",
    friends: "الأصدقاء",
    points: "النقاط",
    top5Friends: "أفضل 5 أصدقاء",
    addToTop5: "أضف للمفضلة",
    removeFromTop5: "أزل من المفضلة",
    sendMessage: "أرسل رسالة",
    addFriend: "أضف صديق",
    friendRequestSent: "تم إرسال طلب الصداقة",
    
    // Communities
    joinCommunity: "انضم للمجتمع",
    leaveCommunity: "غادر المجتمع",
    members: "أعضاء",
    groupChat: "محادثة جماعية",
    communityFeed: "خلاصة المجتمع",
    
    // Travel
    travelingTo: "السفر إلى",
    destination: "الوجهة",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    lookingFor: "أبحث عن",
    postTrip: "نشر رحلة",
    
    // Admin
    adminDashboard: "لوحة الإدارة",
    users: "المستخدمون",
    analytics: "التحليلات",
    broadcast: "بث",
    sendBroadcast: "إرسال بث",
    broadcastTitle: "عنوان البث",
    broadcastMessage: "رسالة البث",
    
    // Languages
    selectLanguage: "اختر اللغة",
    english: "الإنجليزية",
    spanish: "الإسبانية",
    portuguese: "البرتغالية",
    french: "الفرنسية",
    german: "الألمانية",
    chinese: "الصينية",
    hindi: "الهندية",
    italian: "الإيطالية",
    korean: "الكورية",
    arabic: "العربية",
    japanese: "اليابانية",
    
    // Errors
    error: "خطأ",
    somethingWentWrong: "حدث خطأ ما",
    tryAgain: "حاول مرة أخرى",
    invalidCredentials: "بيانات دخول غير صحيحة",
    
    // Time
    justNow: "الآن",
    minutesAgo: "دقائق مضت",
    hoursAgo: "ساعات مضت",
    daysAgo: "أيام مضت",
    
    // Footer
    madeWithEmergent: "صنع بواسطة Emergent",
  },

  // Japanese translations - Complete
  ja: {
    // Common
    sqawk: "sQawk",
    loading: "読み込み中...",
    save: "保存",
    cancel: "キャンセル",
    close: "閉じる",
    search: "検索",
    submit: "送信",
    delete: "削除",
    edit: "編集",
    share: "共有",
    copy: "コピー",
    copied: "コピーしました！",
    
    // Auth
    welcomeBack: "おかえりなさい",
    signInToContinue: "続けるにはサインインしてください",
    signIn: "サインイン",
    signUp: "新規登録",
    email: "メールアドレス",
    password: "パスワード",
    forgotPassword: "パスワードをお忘れですか？",
    rememberMe: "ログイン状態を保持",
    dontHaveAccount: "アカウントをお持ちでない方",
    alreadyHaveAccount: "すでにアカウントをお持ちですか？",
    login: "ログイン",
    logout: "ログアウト",
    
    // Landing Page
    sqawkAcrossTheWorld: "世界中のsQawk。",
    createProfile: "今日からsQawkプロフィールを作成しよう",
    joinGlobalCommunity: "グローバルコミュニティに参加してつながりましょう",
    getStarted: "始める",
    learnMore: "詳細を見る",
    webelieve: "私たちは信じています",
    conversationBeatsClout: "会話は影響力に勝る。コミュニティはバイラルに勝る。本物はアルゴリズムに勝る。",
    socialMediaForPeople: "これは人々のためのSNSです。",
    notForInfluencers: "インフルエンサーのためのSNSではありません。",
    
    // Navigation
    home: "ホーム",
    findTravelFriends: "旅友を探す",
    notifications: "通知",
    messages: "メッセージ",
    communities: "コミュニティ",
    profile: "プロフィール",
    settings: "設定",
    admin: "管理",
    goLive: "ライブ配信",
    
    // Dashboard
    myTop5Squad: "マイトップ5",
    feed: "フィード",
    forYou: "おすすめ",
    sqawks: "投稿",
    whatsHappening: "今何してる？",
    shareTo: "共有先",
    mainFeedOnly: "メインフィードのみ",
    addSqawk: "投稿する",
    
    // Features
    customizeYourProfile: "プロフィールをカスタマイズ",
    makeProfileUnique: "あなただけのプロフィールを作ろう",
    editProfile: "プロフィールを編集",
    findFriends: "友達を探す",
    findTravelers: "旅行者を探す",
    connectWithTravelers: "同じ方向に向かう旅行者とつながろう",
    petPicsOfTheDay: "今日のペット写真",
    shareFurryFriends: "かわいいペットをシェアしよう！",
    joinPetCommunity: "ペットコミュニティに参加",
    shareMyBusiness: "ビジネスをシェア",
    addCompanyInfo: "会社情報を追加",
    addBusiness: "ビジネスを追加",
    
    // Quick Access
    quickAccess: "クイックアクセス",
    sqawkTrends: "sQawkトレンド",
    sqawkCommunities: "sQawkコミュニティ",
    travelFriends: "旅友",
    myBusiness: "マイビジネス",
    boostPromote: "ブースト＆プロモート",
    
    // Notifications
    enableNotifications: "通知を有効にする",
    notificationsEnabled: "通知が有効になりました！",
    notificationPromptTitle: "通知を有効にする",
    notificationPromptBody: "アプリを閉じていても、トップ5の友達が投稿したら通知を受け取れます！",
    enable: "有効にする",
    notNow: "今はしない",
    notificationsBlocked: "通知がブロックされています",
    enableInBrowserSettings: "ブラウザの設定で通知を有効にしてください。",
    
    // Posts
    like: "いいね",
    comment: "コメント",
    resqawk: "リスクォーク",
    postSqawk: "投稿",
    addPhoto: "写真を追加",
    addVideo: "動画を追加",
    addLocation: "場所を追加",
    tagFriends: "友達をタグ付け",
    
    // Profile
    posts: "投稿",
    friends: "友達",
    points: "ポイント",
    top5Friends: "トップ5の友達",
    addToTop5: "トップ5に追加",
    removeFromTop5: "トップ5から削除",
    sendMessage: "メッセージを送る",
    addFriend: "友達を追加",
    friendRequestSent: "友達リクエストを送信しました",
    
    // Communities
    joinCommunity: "コミュニティに参加",
    leaveCommunity: "コミュニティを退出",
    members: "メンバー",
    groupChat: "グループチャット",
    communityFeed: "コミュニティフィード",
    
    // Travel
    travelingTo: "旅行先",
    destination: "目的地",
    startDate: "開始日",
    endDate: "終了日",
    lookingFor: "探している",
    postTrip: "旅行を投稿",
    
    // Admin
    adminDashboard: "管理ダッシュボード",
    users: "ユーザー",
    analytics: "アナリティクス",
    broadcast: "ブロードキャスト",
    sendBroadcast: "ブロードキャストを送信",
    broadcastTitle: "ブロードキャストタイトル",
    broadcastMessage: "ブロードキャストメッセージ",
    
    // Languages
    selectLanguage: "言語を選択",
    english: "英語",
    spanish: "スペイン語",
    portuguese: "ポルトガル語",
    french: "フランス語",
    german: "ドイツ語",
    chinese: "中国語",
    hindi: "ヒンディー語",
    italian: "イタリア語",
    korean: "韓国語",
    arabic: "アラビア語",
    japanese: "日本語",
    
    // Errors
    error: "エラー",
    somethingWentWrong: "問題が発生しました",
    tryAgain: "再試行",
    invalidCredentials: "認証情報が無効です",
    
    // Time
    justNow: "たった今",
    minutesAgo: "分前",
    hoursAgo: "時間前",
    daysAgo: "日前",
    
    // Footer
    madeWithEmergent: "Emergentで作成",
  },

  // Russian translations - Complete
  ru: {
    // Common
    sqawk: "sQawk",
    loading: "Загрузка...",
    save: "Сохранить",
    cancel: "Отмена",
    close: "Закрыть",
    search: "Поиск",
    submit: "Отправить",
    delete: "Удалить",
    edit: "Редактировать",
    share: "Поделиться",
    copy: "Копировать",
    copied: "Скопировано!",
    
    // Auth
    welcomeBack: "С возвращением",
    signInToContinue: "Войдите, чтобы продолжить",
    signIn: "Войти",
    signUp: "Регистрация",
    email: "Электронная почта",
    password: "Пароль",
    forgotPassword: "Забыли пароль?",
    rememberMe: "Запомнить меня",
    dontHaveAccount: "Нет аккаунта?",
    alreadyHaveAccount: "Уже есть аккаунт?",
    login: "Вход",
    logout: "Выход",
    
    // Landing Page
    sqawkAcrossTheWorld: "sQawk По Всему Миру.",
    createProfile: "Создайте свой профиль sQawk сегодня",
    joinGlobalCommunity: "Присоединяйтесь к глобальному сообществу и начните общаться",
    getStarted: "Начать",
    learnMore: "Узнать больше",
    webelieve: "Мы верим",
    conversationBeatsClout: "Общение важнее влияния. Сообщество важнее вирусности. Подлинность важнее алгоритмов.",
    socialMediaForPeople: "Это социальная сеть для людей.",
    notForInfluencers: "Это не социальная сеть для инфлюенсеров.",
    
    // Navigation
    home: "Главная",
    findTravelFriends: "Найти попутчиков",
    notifications: "Уведомления",
    messages: "Сообщения",
    communities: "Сообщества",
    profile: "Профиль",
    settings: "Настройки",
    admin: "Админ",
    goLive: "Трансляция",
    
    // Dashboard
    myTop5Squad: "Мой Топ 5",
    feed: "Лента",
    forYou: "Для вас",
    sqawks: "Посты",
    whatsHappening: "Что происходит?",
    shareTo: "Поделиться в",
    mainFeedOnly: "Только основная лента",
    addSqawk: "Добавить sQawk",
    
    // Features
    customizeYourProfile: "Настройте свой профиль",
    makeProfileUnique: "Сделайте свой профиль уникальным",
    editProfile: "Редактировать профиль",
    findFriends: "Найти друзей",
    findTravelers: "Найти путешественников",
    connectWithTravelers: "Свяжитесь с путешественниками по пути",
    petPicsOfTheDay: "Фото питомцев дня",
    shareFurryFriends: "Поделитесь фото своих питомцев!",
    joinPetCommunity: "Присоединиться к сообществу питомцев",
    shareMyBusiness: "Поделиться бизнесом",
    addCompanyInfo: "Добавить информацию о компании",
    addBusiness: "Добавить бизнес",
    
    // Quick Access
    quickAccess: "Быстрый доступ",
    sqawkTrends: "Тренды sQawk",
    sqawkCommunities: "Сообщества sQawk",
    travelFriends: "Попутчики",
    myBusiness: "Мой бизнес",
    boostPromote: "Продвижение",
    
    // Notifications
    enableNotifications: "Включить уведомления",
    notificationsEnabled: "Уведомления включены!",
    notificationPromptTitle: "Включить уведомления",
    notificationPromptBody: "Получайте уведомления, когда ваши Топ 5 друзей публикуют посты!",
    enable: "Включить",
    notNow: "Не сейчас",
    notificationsBlocked: "Уведомления заблокированы",
    enableInBrowserSettings: "Включите уведомления в настройках браузера.",
    
    // Posts
    like: "Нравится",
    comment: "Комментарий",
    resqawk: "Репост",
    postSqawk: "Опубликовать",
    addPhoto: "Добавить фото",
    addVideo: "Добавить видео",
    addLocation: "Добавить место",
    tagFriends: "Отметить друзей",
    
    // Profile
    posts: "Посты",
    friends: "Друзья",
    points: "Очки",
    top5Friends: "Топ 5 друзей",
    addToTop5: "Добавить в Топ 5",
    removeFromTop5: "Удалить из Топ 5",
    sendMessage: "Отправить сообщение",
    addFriend: "Добавить в друзья",
    friendRequestSent: "Запрос в друзья отправлен",
    
    // Communities
    joinCommunity: "Вступить в сообщество",
    leaveCommunity: "Покинуть сообщество",
    members: "участников",
    groupChat: "Групповой чат",
    communityFeed: "Лента сообщества",
    
    // Travel
    travelingTo: "Путешествие в",
    destination: "Направление",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    lookingFor: "Ищу",
    postTrip: "Опубликовать поездку",
    
    // Admin
    adminDashboard: "Панель администратора",
    users: "Пользователи",
    analytics: "Аналитика",
    broadcast: "Рассылка",
    sendBroadcast: "Отправить рассылку",
    broadcastTitle: "Заголовок рассылки",
    broadcastMessage: "Сообщение рассылки",
    
    // Languages
    selectLanguage: "Выбрать язык",
    english: "Английский",
    spanish: "Испанский",
    portuguese: "Португальский",
    french: "Французский",
    german: "Немецкий",
    chinese: "Китайский",
    hindi: "Хинди",
    italian: "Итальянский",
    korean: "Корейский",
    arabic: "Арабский",
    japanese: "Японский",
    russian: "Русский",
    
    // Errors
    error: "Ошибка",
    somethingWentWrong: "Что-то пошло не так",
    tryAgain: "Попробовать снова",
    invalidCredentials: "Неверные учетные данные",
    
    // Time
    justNow: "Только что",
    minutesAgo: "минут назад",
    hoursAgo: "часов назад",
    daysAgo: "дней назад",
    
    // Footer
    madeWithEmergent: "Сделано с Emergent",
    
    // Directory / Business specific
    directory: "Каталог",
    globalDirectory: "Глобальный каталог",
    dollarDirectory: "$1 Глобальный каталог",
    businesses: "Бизнесы",
    allCategories: "Все категории",
    featured: "Избранное",
    newest: "Новые",
    popular: "Популярные",
    nearYou: "Рядом с вами",
    viewBusiness: "Посмотреть бизнес",
    contactBusiness: "Связаться",
    visitWebsite: "Посетить сайт",
    callNow: "Позвонить",
    getDirections: "Маршрут",
    reviews: "Отзывы",
    rating: "Рейтинг",
    openNow: "Открыто сейчас",
    closed: "Закрыто",
    priceRange: "Ценовой диапазон",
    category: "Категория",
    location: "Местоположение",
    description: "Описание",
    services: "Услуги",
    products: "Товары",
    aboutBusiness: "О бизнесе",
    businessHours: "Часы работы",
    contactInfo: "Контактная информация",
    socialLinks: "Социальные сети",
    claimBusiness: "Заявить права на бизнес",
    reportBusiness: "Пожаловаться",
    shareBusiness: "Поделиться бизнесом",
    addToFavorites: "В избранное",
    removeFromFavorites: "Удалить из избранного",
    writeReview: "Написать отзыв",
    seeAllReviews: "Все отзывы",
    filterByCategory: "Фильтр по категории",
    sortBy: "Сортировать по",
    searchBusinesses: "Поиск бизнесов",
    noBusinessesFound: "Бизнесы не найдены",
    loadMore: "Загрузить ещё",
    verified: "Проверено",
    premium: "Премиум",
    sponsored: "Реклама",
  }
};

// Get browser language and return supported language code
export const getDefaultLanguage = () => {
  const browserLang = navigator.language?.split('-')[0] || 'en';
  return ['en', 'es', 'pt', 'fr', 'de', 'zh', 'hi', 'it', 'ko', 'ar', 'ja', 'ru'].includes(browserLang) ? browserLang : 'en';
};

// Translation hook helper
export const useTranslation = (language) => {
  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };
  return { t };
};

export default translations;
